import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import CloseIcon from '@material-ui/icons/Close';
import { IconButton } from '@tecsinapse/ui-kit';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import WarningIcon from '@material-ui/icons/Warning';
import { withStyles } from '@material-ui/core/styles';
import {
  defaultGreen,
  defaultGrey,
  defaultOrange,
  defaultRed,
} from '../../app/globalStyle';

const variantIcon = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon,
};

const styles = theme => ({
  success: {
    backgroundColor: defaultGreen,
    color: 'white',
    '&$disabled': {
      backgroundColor: defaultGrey,
    },
  },
  error: {
    backgroundColor: defaultRed,
    color: 'white',
    '&$disabled': {
      backgroundColor: defaultGrey,
    },
  },
  info: {
    backgroundColor: defaultGrey,
  },
  warning: {
    backgroundColor: defaultOrange,
    color: 'white',
    '&$disabled': {
      backgroundColor: defaultGrey,
    },
  },
  icon: {
    fontSize: 20,
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing(1),
  },
  message: {
    display: 'flex',
    alignItems: 'center',
  },
  disabled: {},
});

function StyledSnackbarContentUI(props) {
  const { classes, className, message, onClose, variant, ...other } = props;
  const Icon = variantIcon[variant];

  return (
    <SnackbarContent
      className={clsx(classes[variant], className)}
      aria-describedby="client-snackbar"
      message={
        <span id="client-snackbar" className={classes.message}>
          <Icon className={clsx(classes.icon, classes.iconVariant)} />
          {message}
        </span>
      }
      action={[
        <IconButton
          key="close"
          aria-label="Close"
          color="inherit"
          className={classes.close}
          onClick={onClose}
        >
          <CloseIcon className={classes.icon} />
        </IconButton>,
      ]}
      {...other}
    />
  );
}

export const StyledSnackbarContent = withStyles(styles)(
  StyledSnackbarContentUI
);

StyledSnackbarContentUI.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  message: PropTypes.node,
  onClose: PropTypes.func,
  variant: PropTypes.oneOf(['success', 'warning', 'error', 'info']).isRequired,
};

StyledSnackbarContentUI.defaultProps = {
  className: '',
  message: '',
  onClose: () => null,
};
